module.exports = __webpack_public_path__ + "img/transfervr-logo.9f53acba.jpg";